import { useEffect, useState } from "react";
import OvalIconButton from "../../../../Component/Elements/Button/OvalIconButton/OvalIconButton";
import DetailIcon from "../../../../Component/Elements/Icon/DetailIcon/DetailIcon";
import ReactPhotoSwipeSingleViewer from "../../../../Component/Elements/ReactPhotoSwipeGallery/ReactPhotoSwipeSingleViewer";

const FolderImageViewer = (
    {
        img_src,
        btn_type,
        children,
    }:{
        img_src: string;
        btn_type: "button" | "icon";
        children?: React.ReactNode;
    }
) => {

    const [node, setNode] = useState<React.ReactNode | null>(null);

    useEffect(() => {
        if(children){
            setNode(children);
        }else{
            switch(btn_type){
                case "button":
                    setNode(
                        <OvalIconButton
                            preset={"detail_view"}
                        />
                    )
                    break;
                case "icon":
                    setNode(
                        <DetailIcon
                            size={"large"}
                        />
                    )
                    break;
            }   
        }
    }, [children, btn_type])

    if(img_src){
        return(
            <div>
                <ReactPhotoSwipeSingleViewer
                    origin_url={img_src}
                    thumbnail_url={img_src}
                >
                    {node}
                </ReactPhotoSwipeSingleViewer>
            </div>
        )
    }else{
        return null;
    }
}

export default FolderImageViewer;